import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Sortable } from '@components/Albums/TableView/style';

const SortableButton = ({ text, onClick, order }) => (
  <Sortable type="button" onClick={onClick}>
    {text}

    <Icon width="16" height="16" viewBox="0 0 16 16">
      {order === 'asc' || order === '' ? <path d="M11 7h-6l3-4z" /> : null}
      {order === 'desc' || order === '' ? <path d="M5 9h6l-3 4z" /> : null}
    </Icon>
  </Sortable>
);

SortableButton.propTypes = {
  text: PropTypes.string.isRequired,
  order: PropTypes.oneOf(['asc', 'desc', '']).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SortableButton;
